export default {
    state: {

    },
    mutations: {

        SET_NOTIFICATIONS_COUNT(state, count){
            state.user.notifications_count =  count;
        },
    },
    actions: {
        createNotification(context, payload){
            let url = '/notifications/create';
            return window.axios.post(url, {...payload});
            
        },
        markAllAsRead({commit}){

            let url = '/notifications/read';
            return window.axios.post(url).then(()=>{
                commit('SET_NOTIFICATIONS_COUNT', 0);
            });
            
        },
    }
}